import { createContext } from 'react';
import { IFieldListItem, IListItem } from './interfaces';

export interface IListItems {
    rowData: IListItem[];
    fields: IFieldListItem[];
    axisTypes: IListItem[];
    dateSeriesTypes: IListItem[];
    numericSeriesTypes: IListItem[];
    operators: IListItem[];
    ruleOperators: IListItem[];
    booleanOperators: IListItem[];
}

export const Context = createContext<{
    organisationId: string;
    studyId: string;
    listItems: IListItems;
    hasFilters: boolean;
}>({
    organisationId: '',
    studyId: '',
    listItems: {
        rowData: [],
        fields: [],
        axisTypes: [],
        dateSeriesTypes: [],
        numericSeriesTypes: [],
        operators: [],
        ruleOperators: [],
        booleanOperators: [],
    },
    hasFilters: false,
});
